import React from "react";
import { styled } from "@mui/material";
import { EmbeddedChat } from "dialogue/src/EmbeddedChat";

//region [[ Styles ]]

const PatientCardDialogueView = styled("div")<{
  hasMaxWidth: boolean;
  rtlDisplay: boolean;
}>(({ hasMaxWidth, rtlDisplay }) => ({
  position: "relative",
  height: "100%",
  maxWidth: hasMaxWidth ? 620 : "100%",
  minWidth: 440,
  overflow: "hidden",
  flex: "1 0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: rtlDisplay ? "0 -18px 0 0" : "0 0 0 -18px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientCardDialogueProps {
  loading?: boolean;
  rtlDisplay?: boolean;
  hasMaxWidth?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

export const PatientCardDialogue = ({
  loading,
  hasMaxWidth,
  rtlDisplay,
}: PatientCardDialogueProps) => {
  return (
    <PatientCardDialogueView
      hasMaxWidth={hasMaxWidth}
      rtlDisplay={rtlDisplay}
      className={"patient-card-dialogue"}
    >
      <EmbeddedChat loading={loading} />
    </PatientCardDialogueView>
  );
};
